module.exports = __webpack_public_path__ + "static/media/qrIcon.74c80c78.svg";